import { Alert } from 'element-ui'

const YAlert = Alert
YAlert.$depends = [Alert]
YAlert.$name = 'y-alert'
YAlert._name = 'Alert 警告'

export default YAlert
